import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-mail-confirm-modal',
  templateUrl: './mail-confirm-modal.component.html',
  styleUrls: ['./mail-confirm-modal.component.scss'],
})
export class MailConfirmModalComponent {
  @Output() confirmed = new EventEmitter<void>();

  onConfirm() {
    this.confirmed.emit();
  }
}
